import { render, staticRenderFns } from "./FamiliesDonut.vue?vue&type=template&id=17fac8de&scoped=true"
import script from "./FamiliesDonut.vue?vue&type=script&lang=js"
export * from "./FamiliesDonut.vue?vue&type=script&lang=js"
import style0 from "./FamiliesDonut.vue?vue&type=style&index=0&id=17fac8de&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fac8de",
  null
  
)

export default component.exports